<template>
  <div>
    <MenuBar />

    <div id="faqPage" class="mobileOnly">
      <FloatingMenu />

      <transition enter-active-class="animated fadeIn" appear>
        <div class="faqPageTitle">
          <span v-if="this.langChosen === 'gr'">자주하는 질문</span>
          <span v-else>FAQ</span>
        </div>
      </transition>

      <div class="faqContainer" v-if="this.langChosen === 'gr'">
        <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
          <div
            class="faqHead"
            @click="oneActive = !oneActive"
            :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
            key="headOne"
          >
            <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
            <div>경품 행사는 어떻게 신청합니까?</div>
          </div>

          <div class="faqBody" v-if="oneActive" key="bodyOne">
            <p>
              <b>요구 사항 및 지침</b>
            </p>

            <p>커뮤니티 납세 증명서, 신분증, 상품권을 방콕의 복권 본부로 전송하기 만하면됩니다.</p>

            <p>
              뮤추얼 펀드, 회계 및 예산 부서에 당첨 티켓을 보여주십시오. 당첨 티켓 뒷면에 귀하의 진정한 소유권을
              나타내는 서명을 넣으십시오. 청구 양식 작성
            </p>

            <p>
              재무부로 이동하십시오. 수표를 즉시 준비 할 수 있도록 인증 된 티켓과 승인 된 신청서를 제시하십시오
            </p>

            <p>사장 / 총지배인의 수표에 서명하십시오. 그런 다음 재무부에서 보상 / 정확하게 확인하세요</p>
            <p>방콕 국립 은행에 수표를 입력하십시오</p>

            <p>
              <b>상품 지불 조건</b>
            </p>

            <p>
              티켓이 절단, 삭제 또는 얼룩이 없어서 번호를 읽을 수없는 경우 제시 및 배송시 주주 또는 보너스 티켓에 상금이
              지급됩니다. 다음과 같은 조건을 가질 수 있습니다. 지불 전 산토리니 복권 지불을 제한하는 법원 명령을받지
              않았습니다.
            </p>

            <p>지불 된 모든 보상은 면세입니다..</p>
          </div>

          <div
            class="faqHead"
            @click="twoActive = !twoActive"
            :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
            key="headTwo"
          >
            <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
            <div>로또 상품은 어떻게받을 수 있나요?</div>
          </div>

          <div class="faqBody" v-if="twoActive" key="bodyTwo">
            <p>상품을 받기 전에 이름을 쓰고 당첨 티켓 뒷면에 서명을하십시오.</p>

            <p>
              공인 로또 샵이나 지역 복권 지점에서 € 1 ~ € 100 상품을받을 수 있습니다
            </p>

            <p>
              3.500 바트 이상, 최대 125.000 바트의 상금은 방콕 복권 본사에서받을 수 있습니다
            </p>

            <p>
              잭팟 상품은 산토리니의 복권 본부에서 검토하고 청구해야합니다
            </p>

            <p>시스템 비용을 지불하려면 보상 계획을 참조하십시오</p>
          </div>

          <div
            class="faqHead"
            @click="threeActive = !threeActive"
            :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
            key="headThree"
          >
            <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
            <div>온라인 복권 로고 신청 방법</div>
          </div>

          <div class="faqBody" v-if="threeActive" key="bodyThree">
            <ol>
              <li>
                신청자는 공식 부름을 위해 신청서를 작성해야합니다.
                <br />신청서에는 다음과 같은 첨부 파일이 포함되어 있습니다.:
              </li>

              <ul>
                <li>제안 된 판매 지역의 건물 그림.</li>
              </ul>

              <li>
                판매용으로 제공된 사이트에 대한 기술 검토 및 평가를 수행합니다..
              </li>

              <li>
                지원자에게는 평가 결과가 통보됩니다. 권장 판매 위치가 지속 가능하려면 다음이 필요합니다.
              </li>

              <ul>
                <li>개별 지원자 용</li>
                <li>기업용</li>
              </ul>

              <li>
                산토리니 복권은 신청자에게 신청 상태를 알려줍니다. 설치 전에 제안 된 시장에서 통신 시설의 가용성.
                편리한.
              </li>

              <li>팔레트를 만들 때 신청자에게 알려야합니다.</li>
              <li>터미널을 설치하려면</li>
              <li>처리 수수료를 지불하고 산토리니 복권으로 지불합니다.</li>
              <li>방콕 복권 설치비 지불</li>
              <li>GSIS에 대한 지급 보장</li>
              <li>터미널 운영 중 교육 신청</li>

              <li>
                물품을 위해 컨테이너 부서로 가면 추첨은 방콕 복권에서 제공됩니다.
              </li>

              <li>기업 계약 체결</li>
              <li>온라인 활성화 용</li>
            </ol>

            <p>
              <b> 노트:</b>
            </p>

            <ul>
              <li>
                신청서가 완전하고 모든 필수 서류가 첨부되었는지 확인하십시오. 불완전한 청구는 처리되지 않습니다.
              </li>

              <li>모든 신청서는 사전 승인 검토를받습니다.</li>
            </ul>
          </div>

          <div
            class="faqHead"
            @click="fourActive = !fourActive"
            :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
            key="headFour"
          >
            <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
            <div>복권 신청 요건</div>
          </div>

          <div class="faqBody" v-if="fourActive" key="bodyFour">
            <ol type="A">
              <li>지원자는:</li>

              <ul>
                <li>그리스 시민</li>
                <li>21 세 이상</li>
              </ul>

              <li>지원자는 작성하여 제출해야합니다.:</li>

              <ul>
                <li>개별 지원자:</li>

                <ol>
                  <li>สาม (3) รหัสสุดท้าย (2 x 2)</li>

                  <li>
                    배우자의 최근 사진 3 장 (2 x 2) 의향서 온라인 추첨 개인 정보 시트;
                  </li>

                  <li>소득 증명:</li>

                  <ul>
                    <li>자영업자:</li>

                    <ul>
                      <li>소득세 환급</li>
                      <li>사업자 등록</li>
                      <li>감사 재무 제표</li>
                    </ul>

                    <li>직원 용:</li>

                    <ul>
                      <li>소득세 환급</li>
                      <li>사업자 등록</li>
                      <li>소득 증명서</li>
                    </ul>
                  </ul>

                  <li>출구 소유권 / 임대 증명</li>

                  <ul>
                    <li>소유자를 위해:</li>

                    <ul>
                      <li>소유권 증서 또는 TCT</li>
                    </ul>

                    <li>세입자 용:</li>

                    <ul>
                      <li>보증</li>
                      <li>건물 인수 승인 양식</li>
                    </ul>
                  </ul>

                  <li>NBI 허가 (현재)</li>

                  <li>
                    조직이 제공하는 웹 사이트의 정리 (개인 등록) 초안 / 사이트 맵.
                  </li>

                  <li>건물 기후 사진</li>
                  <li>인테리어 사진</li>
                </ol>

                <li>기업용:</li>

                <ol>
                  <li>기업 임원 및 이사의 생체 인식</li>

                  <li>
                    정관 사본, 마지막 재무 감사를받은 법률 사본, I.T.R. 전년도 즉시, 의향서, 소유자 스케치 / 제작 임대
                    계약 사진을 제공하는 사무실 웹 사이트의 사이트 맵 건물 주변 사진
                  </li>

                  <li>인테리어 사진</li>
                </ol>
              </ul>

              <li>
                신청자는 제안 된 조직의 웹 사이트가 다음 기준을 충족해야합니다.
              </li>

              <ol>
                <li>
                  추첨 정책에 따라 학교 / 공부 장소에서 100m 떨어져 있습니다. 산토리니와 규칙은 웹 사이트 나 쇼핑몰이
                  폐쇄되지 않는 한 존재합니다.
                </li>

                <li>
                  예를 들어 교차로 / 상업 지역 또는 바쁜 지역에서 사람이 잘 통행합니다. 터미널에서의 그의 위치 / 부스는
                  쇼핑몰 내부이든 내부이든 전략적이어야합니다. 슈퍼마켓
                </li>

                <li>지역은 범람하지 않습니다</li>

                <li>
                  바닥 면적 8-9m2 또는 최소 1.0m X 0.5m 크기의 비즈니스 미터
                </li>

                <li>
                  특히 관리를 위해 적어도 하나의 고정 또는 휴대 전화 설정이 필요합니다. 전화선 열어 줘 (특히 집 전화)
                  거리 내에 있어야합니다. 제안 된 목적지 사이트에서 1 미터 떨어져 있습니다.
                </li>

                <li>
                  폐쇄 (안전을 위해), 그러나 사람이 통행 할 수있는 전면이 있습니다. 주요 도로를 향하거나 교통량이 많은
                  경우 백화점, 백화점 또는 슈퍼마켓이 반드시 복권의 본거지 인 것은 아닙니다. 특히 보관 시간 이후에 작동
                  안전이있는 경우 포함됩니다.
                </li>

                <li>적절한 건조 지역 및 환기 (바람직하게는 에어컨 사용)</li>
                <li>사용 가능한 접지 및 전원 지점이있는 일반 220VAC 전원 공급 장치를 사용합니다.</li>

                <li>
                  모뎀 커넥터 및 복권 보관을위한 선반 / 미터 / 테이블 포함. 담당자가없는 경우 완료시 알림
                </li>

                <li>
                  터미널 운영 교육을받을 준비가 된 운영자는 터미널 당 특수 요원 1 명과 예비 요원 1 명. 이 담당자에게
                  알림이 전송됩니다. 조종사는 언제 훈련을받을 것인가
                </li>

                <li>주요 영업 시간은 주 7 일 오전 7시 ~ 오후 8시 30 분입니다.</li>
              </ol>

              <li>
                기존 로또 상점에서 최소 100m 떨어져 있습니다. 산토리니 복권.
              </li>

              <li>승인 된 서비스 제공 업체의 사이트에 대한 기술 검토.</li>
            </ol>
          </div>

          <div
            class="faqHead"
            @click="fiveActive = !fiveActive"
            :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
            key="headFive"
          >
            <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
            <div>의료 지원에 대한 요구 사항은 무엇입니까?</div>
          </div>

          <div class="faqBody" v-if="fiveActive" key="headFive">
            <ul>
              <li>약물 요청</li>

              <ul>
                <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                <li>
                  정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                </li>

                <li>
                  병원 약국에서 비용을 지불하고 치료 의사가 서명 한 처방전에는 다음이 포함됩니다.
                  <br />
                  병원 약국 A의 약이 없을 때 복권에 병원 약국에서 약 없음 증명서 부산
                </li>

                <li>
                  뒷면에 신청자의 서명이있는 신청자의 마지막 사진이있는 신분증 사본.
                </li>
              </ul>

              <li>실험실 애플리케이션 / 진단 절차</li>

              <ul>
                <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                <li>
                  정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                </li>

                <li>
                  치료 의사를 위해 정식으로 서명 된 신청서 (참고 : 의사 면허 번호 포함)
                </li>

                <li>
                  병원의 실험실 부서 /과에서 공식 가격을 제공합니다.
                  <br />
                  검사실 / 진단 절차를 사용할 수없는 경우 병원은 병원에서 시술 불가 증명서를 제출해야합니다. 산토리니
                  복권.
                </li>

                <li>
                  뒷면에 신청자의 서명이있는 신청자의 마지막 사진이있는 신분증 사본.
                </li>
              </ul>

              <li>입원금 요청</li>

              <ul>
                <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                <li>
                  정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                </li>

                <li>
                  계정 / 병원 청구서는 청구 / 신용 감독자가 검토합니다.
                </li>

                <li>
                  해당되는 경우 병원의 사회 복지 부서 또는 관리자의 추천서. 인증 및 청구
                </li>
              </ul>

              <li>보청기 요청</li>

              <ul>
                <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                <li>
                  청력 학자가 서명 한 오디오 평가 보고서 원본.
                </li>

                <li>모든 청각 센터에서 한두 가지 가격.</li>
                <li>신청자의 마지막 사진이 서명 된 주민등록증 사본.</li>
              </ul>

              <li>임플란트 / 보철물 / 휠체어 요청</li>

              <ul>
                <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                <ol>
                  <li>이식 요청 / 서약</li>

                  <ul>
                    <li>
                      정식으로 서명 된 의료 요약의 원본 또는 인증 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                    </li>
                  </ul>

                  <li>휠체어 요청</li>

                  <ul>
                    <li>
                      의료 요약 또는 이용 가능한 의료 증명서의 원본 또는 인증 된 실제 사본. 치료 의사가 서명 한 휠체어
                      세부 정보 (참고 : 의사 면허 번호 포함)
                    </li>
                  </ul>
                </ol>

                <li>공식 가격, 두 (2) 다른 회사의 두 (2) 가격.</li>

                <li>
                  휠체어 및 보철 장치를 요청하는 환자의 신체 이미지 1 개.
                </li>
              </ul>

              <li>투석 요청</li>

              <ul>
                <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                <li>
                  정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                </li>

                <li>
                  부산 복권이 돈을 기부 한 콜센터 또는 병원의 승인서.
                </li>

                <li>고객 서비스 센터 / 병원의 공식 가격 견적.</li>
                <li>투석 센터 / 병원의 합격 증명서</li>

                <li>
                  수술 후 병원에 용제 및 / 또는 약물이없는 경우 투석액 및 / 및 수술 후 약물을 병원에서 구할 수없는 경우
                  산토리니 복권 인증에 제출해야합니다.
                </li>

                <li>
                  뒷면에 신청자의 서명이있는 신청자의 마지막 사진이있는 신분증 사본.
                </li>
              </ul>
            </ul>
          </div>

          <div class="stillHaveQuestion" key="stillHaveQuestion">
            여전히 질문이 있습니까? 저희에게 연락하십시오 admin@busanlotteries.com
          </div>
        </transition-group>
      </div>

      <div class="faqContainer" v-else>
        <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
          <div
            class="faqHead"
            @click="oneActive = !oneActive"
            :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
            key="headOne"
          >
            <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
            <div>How to Claim Sweepstakes Prize?</div>
          </div>

          <div class="faqBody" v-if="oneActive" key="bodyOne">
            <p>
              <b>Requirements and Guidelines</b>
            </p>

            <p>
              Simply bring your Community Tax Certificate, Identification Card and the Winning ticket/s to the Busan
              Lottery main office.
            </p>

            <p>
              Present your winning ticket/s at the Prize Fund Division, Accounting and Budget Department. Affix your
              signature at the back of winning ticket/s to establish your absolute ownership. Fill up claim form.
            </p>

            <p>
              Proceed to Treasury Department. Present your Authenticated winning ticket/s and approved claim form for
              immediate preparation of your check.
            </p>

            <p>
              Have your check signed by the Chairman / General Manager. Then properly receive your winning prize / check
              at the Treasury Department.
            </p>

            <p>Encash your check at the Busan National Bank.</p>

            <p>
              <b>Conditions for Payment of Prizes</b>
            </p>

            <p>
              Prizes shall be paid to the holder of share/s of a winning ticket upon presentation and surrender of the
              same, provided that the ticket/s is/are free from any mutilation, erasure or stain, making any number/s
              therein illegible, and provided further that no court injunction restraining the Busan Lottery to pay is
              received before payment.
            </p>

            <p>All prizes paid are tax-free.</p>
          </div>

          <div
            class="faqHead"
            @click="twoActive = !twoActive"
            :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
            key="headTwo"
          >
            <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
            <div>How to Claim Lotto Prize?</div>
          </div>

          <div class="faqBody" v-if="twoActive" key="bodyTwo">
            <p>
              Write your name and affix your signature at the back of your winning tickets before claiming your prize.
            </p>
            <p>
              Prize amounting to 1 EUR up to 100 EUR can be claimed at any authorized Lotto outlet or at the Busan
              Lottery Branch Offices in your area.
            </p>
            <p>
              Prizes worth more than 100 EUR up to 3.500 EUR can be claimed at any of the at the Busan Lottery main
              office.
            </p>
            <p>The JACKPOT PRIZE should be validated and claimed at the Busan Lottery main office.</p>
            <p>For the system prize payout, please refer to the Prize Pay-Out Chart.</p>
          </div>

          <div
            class="faqHead"
            @click="threeActive = !threeActive"
            :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
            key="headThree"
          >
            <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
            <div>How to Apply as an Online Lottery Agent?</div>
          </div>

          <div class="faqBody" v-if="threeActive" key="bodyThree">
            <ol>
              <li>
                The applicant is requested to fill-up the On-Line Lottery Application Form
                <br />The Application Form shall include the following attachments:
              </li>
              <ul>
                <li>Sketch/Location Map of the proposed outlet site.</li>
                <li>Picture of the building of the proposed outlet site.</li>
              </ul>
              <li>
                Busan Lottery shall conduct the inspection and technical evaluation of the proposed outlet site/s.
              </li>
              <li>
                The applicant shall be informed of the evaluation result. If the proposed outlet site is viable, the
                following shall be required:
              </li>
              <ul>
                <li>For Individual Applicant</li>
                <li>For Corporation</li>
              </ul>
              <li>
                Busan Lottery shall notify the applicant on the status of the application concerning the availability
                of communication facilities in the proposed outlet prior to installation of facilities.
              </li>
              <li>The applicant shall be informed when to fabricate lotto booth.</li>
              <li>For Terminal Installation.</li>
              <li>Payment to Busan Lottery for Processing Fee.</li>
              <li>Payment to Busan Lottery of an Installation Fee.</li>
              <li>Payment of Surety Bond to the GSIS.</li>
              <li>Request for training in the operation of terminal.</li>
              <li>
                Proceed to Merchandising Section for outlet provisions. Lottery outlets will be provided by the Busan
                Lottery.
              </li>
              <li>Signing of the Agency Contract with the Busan Lottery.</li>
              <li>For On-Line Activation.</li>
            </ol>

            <p>
              <b>Note:</b>
            </p>
            <ul>
              <li>
                Please ensure that Application Form is complete and that all required documents are attached. Incomplete
                requirements will not be processed.
              </li>
              <li>All application are subject to evaluation prior to approval.</li>
            </ul>
          </div>

          <div
            class="faqHead"
            @click="fourActive = !fourActive"
            :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
            key="headFour"
          >
            <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
            <div>On-Line Lottery Agents’ Application Requirements?</div>
          </div>

          <div class="faqBody" v-if="fourActive" key="bodyFour">
            <ol type="A">
              <li>Applicant must be:</li>
              <ul>
                <li>a Greek citizen</li>
                <li>at least 21 years old</li>
              </ul>
              <li>Applicant must accomplish and submit:</li>
              <ul>
                <li>Individual Applicant:</li>
                <ol>
                  <li>Three (3) latest ID pictures (2 x 2);</li>
                  <li>
                    Three (3) latest ID pictures (2 x 2) of spouse; Letter of INTENT; On-Line Lottery PERSONAL DATA
                    SHEET;
                  </li>
                  <li>Proof of Income:</li>
                  <ul>
                    <li>For Self-employed:</li>
                    <ul>
                      <li>Income Tax Return</li>
                      <li>Registration of Business</li>
                      <li>Audited Financial Statements</li>
                    </ul>
                    <li>For Employed:</li>
                    <ul>
                      <li>Income Tax Return</li>
                      <li>Registration of Business</li>
                      <li>Certificate of Income</li>
                    </ul>
                  </ul>
                  <li>Proof of Ownership/Lease of Outlet</li>
                  <ul>
                    <li>For Owner:</li>
                    <ul>
                      <li>Land Title or TCT</li>
                    </ul>
                    <li>For Lessee:</li>
                    <ul>
                      <li>Contract of Lease (Notarized)</li>
                      <li>Building Owner’s Authorization Form</li>
                    </ul>
                  </ul>
                  <li>NBI Clearance (Current)</li>
                  <li>Brgy Clearance (Personal Record) Sketch/Location Map of the Proposed Agency Site</li>
                  <li>Photograph of the Vicinity Photograph of the Building</li>
                  <li>Photograph of the Interior</li>
                </ol>
                <li>For Corporation:</li>
                <ol>
                  <li>Bio-data of Corporate Officers and Directors</li>
                  <li>
                    Photocopy of S.E.C Registration Photocopy of Articles of Incorporation Photocopy of By Laws Latest
                    audited Financial Statement I.T.R. for the immediately preceding year Letter of Intent Contract of
                    Lease Building Owner’s Authorization Sketch/Location Map of the Proposed Agency Site Photograph of
                    the Vicinity Photograph of the Building
                  </li>
                  <li>Photograph of the Interior</li>
                </ol>
              </ul>

              <li>Applicant must make sure that the Proposed Agency Site must comply with the following criteria:</li>
              <ol>
                <li>
                  100 meters away from schools/place of learning, subject to Busan Lottery policies and existing
                  rules, except if the location is enclosed or a shopping center.
                </li>
                <li>
                  Good human traffic, i.e. situated in commercial or busy intersections/areas. The location of
                  terminal/booth should be strategic if within a mall or superstore.
                </li>
                <li>The area does not get flooded.</li>
                <li>Floor space of 8 – 9 sq. meters or available business counter measuring at least 1.0 m X 0.5 m</li>
                <li>
                  Preferable with at least one (1) telephone facility, landline or cellular, for hotline operations.
                  Such telephone (specially landline) should be situated at no more than one (1) meter away from the
                  proposed terminal location.
                </li>
                <li>
                  Enclosed (for security purposes) but with frontage from human traffic/entry. Frontage must face main
                  road or to the direction of major traffic flow. In cases of malls, shopping centers or superstores,
                  the lottery location need not be enclosed provided there is security of operation, specially after
                  store hours.
                </li>
                <li>Dry floor space and proper ventilation (preferably air-conditioned).</li>
                <li>With regular power supply of 220 VAC, with grounding and available power point/s.</li>
                <li>
                  With available shelf/counter/cabinet for terminal installation, modem and storage of lottery
                  materials. If not currently available, the agent will be advised on when to fabricate.
                </li>
                <li>
                  With operators to be made available for training in the operation of the terminals preferably one
                  dedicated personnel and a back-up personnel per terminal. This agent will be advised on when the
                  operators will be trained.
                </li>
                <li>Major operating hours fall within 7:00AM – 8:30PM, seven (7) days a week.</li>
              </ol>
              <li>
                At least 100 meters away from any existing lotto outlet which shall be subject to Busan Lottery
                governing rules.
              </li>
              <ol>
                <li>National Capital Region – 100M</li>
                <li>Southern Tagalog and Bicol Region – 200 – 250M</li>
                <li>Northern and Central Luzon – 200 – 250M</li>
              </ol>
              <li>Approved technical site survey by carrier.</li>
            </ol>
          </div>

          <div
            class="faqHead"
            @click="fiveActive = !fiveActive"
            :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
            key="headFive"
          >
            <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
            <div>What are the Requirements for Medical Assistance?</div>
          </div>

          <div class="faqBody" v-if="fiveActive" key="headFive">
            <ul>
              <li>Request for Medicines</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>
                <li>
                  Prescription duly signed by the attending physician with costing from the hospital pharmacy included:
                  <br />In cases wherein medicines are unavailable from the Hospital Pharmacy, a Certification on
                  unavailability of medicines from the Hospital Pharmacy must be submitted to Busan Lottery.
                </li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                  indicated at the back.
                </li>
              </ul>
              <li>Request for Laboratory/Diagnostic Procedures</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>
                <li>Request from the attending physician duly signed (Note: Include physician’s license number)</li>
                <li>
                  Official Price Quotation from the Laboratory Section/Department of the Hospital
                  <br />In cases wherein Laboratory/Diagnostic Procedure is unavailable from the hospital, a
                  Certification on unavailability of the procedure from the hospital must be submitted to Busan
                  Lottery.
                </li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                  indicated at the back.
                </li>
              </ul>
              <li>Request for Payment Hospitalization</li>
              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>
                <li>Statement of Account/Hospital Bill certified by the billing Officer/Credit Supervisor.</li>
                <li>
                  Endorsement letter from the hospital’s Social Service if there is any, or from the Credit and
                  Collection Officer for Pay patients.
                </li>
              </ul>
              <li>Request for Hearing Aid</li>

              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                <li>Original copy of Audiological Evaluation Report duly signed by Audiometrist</li>
                <li>One or two price quotations from any hearing aid centers</li>
                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                </li>
              </ul>

              <li>Request for Implants/Prosthetic Devices/Wheelchair</li>

              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>

                <ol>
                  <li>Implant/phosthesis request</li>

                  <ul>
                    <li>
                      Original or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                  </ul>

                  <li>Wheelchair request</li>

                  <ul>
                    <li>
                      Original or certified true photocopy of medical abstract or medical certificate with wheelchair
                      specification signed by the attending physician. (Note: Include physician’s license number)
                    </li>
                  </ul>
                </ol>

                <li>Two (2) official price quotations from two (2) different companies</li>

                <li>
                  One (1) whole body picture of requesting patient for request for wheelchair and prosthetic devices.
                </li>
              </ul>

              <li>Request for Dialysis</li>

              <ul>
                <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>

                <li>
                  Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                  (Note: Include physician’s license number)
                </li>

                <li>
                  Endorsement letter from a Dialysis Center or Hospital where Busan Lottery allots an Endowment Fund
                </li>

                <li>Official Price Quotation from the Dialysis Center/Hospital</li>
                <li>Certification of Acceptance from Dialysis Center/Hospital</li>

                <li>
                  In cases wherein dialysis solution and/or post-operative medicines is unavailable from the hospital, a
                  Certification on unavailability of the dialysis solution and/or post-operative medicines from the
                  hospital must be submitted to the Busan Lottery.
                </li>

                <li>
                  Photocopy of identification card with latest picture of the requesting person with his/her signature
                  indicated at the back.
                </li>
              </ul>
            </ul>
          </div>

          <div class="stillHaveQuestion" key="stillHaveQuestion">
            Still have question? Contact us at admin@busanlottery.com
          </div>
        </transition-group>
      </div>
    </div>

    <div id="faqDesktop">
      <div class="heroHeader">
        <transition enter-active-class="animated fadeIn" appear>
          <div v-if="this.langChosen === 'gr'">Συχνές ερωτήσεις</div>
          <div v-else>Frequently Asked Question</div>
        </transition>
      </div>

      <div class="flex">
        <LeftBannerAds />

        <div class="aboutDesktopField">
          <div v-if="this.langChosen === 'gr'">
            <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
              <div
                class="faqHead"
                @click="oneActive = !oneActive"
                :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
                key="headOne"
              >
                <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
                <div>경품 신청 방법</div>
              </div>

              <div class="faqBody" v-if="oneActive" key="bodyOne">
                <p>
                  <b>요구 사항 및 지침</b>
                </p>

                <p>
                  주민세 증명서, 신분증, 승차권을 부산 본부에서 송금하시면됩니다. 운
                </p>

                <p>
                  뮤추얼 펀드, 회계 및 예산 부서에 당첨 티켓을 보여주십시오. 절대 가치를 결정하기 위해 당첨 티켓 뒷면에
                  서명을하십시오. 귀하의 재산 청구 양식 작성
                </p>

                <p>
                  재무부로 이동하십시오. 인증 된 티켓을 보여주세요 (a) 그리고 즉시 수표 준비를위한 승인 된 신청서.
                </p>

                <p>
                  사장 / 총지배인의 수표에 서명하십시오. 그런 다음 올바른 / 수상자를 얻으십시오. 재무부에서
                  확인하십시오.
                </p>

                <p>부산 중앙 은행에 수표를 입력하세요.</p>

                <p>
                  <b>เงื่อนไขการจ่ายรางวัล상품 지불 조건</b>
                </p>

                <p>
                  상금은 프레젠테이션과 함께 주주 또는 수상 티켓에 지급됩니다. 티켓이 무료라는 조건으로 배달됩니다.
                  절단, 지우기 또는 염색은 숫자를 만듭니다. 읽을 수없고 조건이 있음 산토리니 복권 지급을 제한하는 법원
                  명령을받지 못했습니다. 지불하기 전에.
                </p>

                <p>지불 된 모든 보상은 면세입니다.</p>
              </div>

              <div
                class="faqHead"
                @click="twoActive = !twoActive"
                :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
                key="headTwo"
              >
                <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
                <div>로또 상품을받는 방법</div>
              </div>

              <div class="faqBody" v-if="twoActive" key="bodyTwo">
                <p>
                  이름을 적고 당첨 티켓 뒷면에 서명하십시오. 보상을 받기 전에
                </p>

                <p>
                  1 유로에서 100 유로까지의 상금은 승인 된 사람이 청구 할 수 있습니다. Lotto Shop 또는 지역 복권
                  Santorini 지점에서
                </p>

                <p>
                  100 유로에서 3,500 유로가 넘는 상금은 어느 본사에서나 교환 할 수 있습니다. 산토리니 복권 사무소
                </p>

                <p>
                  잭팟 상품은 산토리니의 복권 본부에서 검토하고 청구해야합니다.
                </p>

                <p>시스템 비용을 지불하려면 보상 계획을 참조하십시오.</p>
              </div>

              <div
                class="faqHead"
                @click="threeActive = !threeActive"
                :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
                key="headThree"
              >
                <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
                <div>온라인으로 복권 로고를 신청하는 방법은 무엇입니까?</div>
              </div>

              <div class="faqBody" v-if="threeActive" key="bodyThree">
                <ol>
                  <li>
                    신청자는 공식 부름을 위해 신청서를 작성해야합니다.
                    <br />
                    신청서에는 다음과 같은 첨부 파일이 있습니다.:
                  </li>
                  <ul>
                    <li>제안 된 판매 지역 위치의 초안 /지도</li>
                    <li>제안 된 판매 지역의 건물 그림</li>
                  </ul>

                  <li>
                    Busan Lotteries는 제공되는 모든 POS에 대한 기술적 검토 및 평가를 수행합니다.
                  </li>

                  <li>
                    지원자에게는 평가 결과가 통보됩니다. 권장 판매 위치가 지속 가능하려면 다음이 필요합니다.
                  </li>

                  <ul>
                    <li>개별 지원자 용</li>
                    <li>기업용</li>
                  </ul>

                  <li>
                    산토리니 복권은 신청자에게 신청 상태를 알려줍니다. 설치 전에 제안 된 시장에서 통신 시설의 가용성.
                    시설.
                  </li>

                  <li>추첨이 생성 될 때 응시자에게 알려야합니다.</li>
                  <li>터미널을 설치하려면</li>
                  <li>처리 수수료를 산토리니 복권으로 지불하십시오.</li>
                  <li>부산 복권 설치비를 지불합니다.</li>
                  <li>GSIS에 대한 보장 된 지불.</li>
                  <li>터미널 작동 중 교육을위한 응용 프로그램입니다.</li>

                  <li>
                    소모품 컨테이너과로 가면 복권은 부산 복권에서 제공합니다.
                  </li>

                  <li>부산 복권과 법인 계약 체결</li>
                  <li>온라인 활성화 용</li>
                </ol>

                <p>
                  <b>노트:</b>
                </p>

                <ul>
                  <li>
                    신청서가 완전하고 모든 필수 서류가 첨부되었는지 확인하십시오. 불완전한 청구는 처리되지 않습니다.
                  </li>

                  <li>모든 신청서는 사전 승인 검토를받습니다.</li>
                </ul>
              </div>

              <div
                class="faqHead"
                @click="fourActive = !fourActive"
                :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
                key="headFour"
              >
                <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
                <div>복권 신청 요건</div>
              </div>

              <div class="faqBody" v-if="fourActive" key="bodyFour">
                <ol type="A">
                  <li>지원자는:</li>
                  <ul>
                    <li>그리스 시민</li>
                    <li>21 세 이상</li>
                  </ul>

                  <li>지원자는 작성하여 제출해야합니다.:</li>

                  <ul>
                    <li>개별 지원자:</li>

                    <ol>
                      <li>3 개의 최종 코드 (2 x 2)</li>

                      <li>
                        배우자의 최근 사진 3 장 (2 x 2) 의향서 온라인 추첨, 개인 정보 시트
                      </li>

                      <li>소득 증명:</li>

                      <ul>
                        <li>자영업자:</li>

                        <ul>
                          <li>소득세 환급</li>
                          <li>사업자 등록</li>
                          <li>감사 재무 제표</li>
                        </ul>

                        <li>직원 용:</li>

                        <ul>
                          <li>소득세 환급</li>
                          <li>사업자 등록</li>
                          <li>소득 증명서</li>
                        </ul>
                      </ul>

                      <li>출구 소유권 / 임대 증명</li>

                      <ul>
                        <li>소유자를 위해:</li>

                        <ul>
                          <li>소유권 증서 또는 TCT</li>
                        </ul>

                        <li>세입자 용:</li>

                        <ul>
                          <li>보증</li>
                          <li>건물 인수 승인 양식</li>
                        </ul>
                      </ul>

                      <li>NBI 허가 (현재)</li>

                      <li>
                        지역 개간 (개인 등록) 제안 된 웹 사이트의 초안 / 사이트 맵. 생물의
                      </li>

                      <li>건물 기후 사진</li>
                      <li>인테리어 사진</li>
                    </ol>

                    <li>기업용:</li>

                    <ol>
                      <li>기업 임원 및 이사의 생체 인식</li>

                      <li>
                        정관 사본, 마지막 재무 감사를받은 법률 사본, I.T.R. 직전 연도, 의향서, 건물 스케치 임대 계약서 /
                        사진을 제공하는 사무실 웹 사이트의 사이트 맵 건물 주변 사진
                      </li>

                      <li>인테리어 사진</li>
                    </ol>
                  </ul>

                  <li>
                    신청자는 제안 된 회사 사이트가 요구 사항을 충족하는지 확인해야합니다. 다음 기준 :
                  </li>

                  <ol>
                    <li>
                      추첨 정책에 따라 학교 / 공부 장소에서 100m 떨어져 있습니다. 산토리니와 규칙은 웹 사이트가
                      폐쇄되거나 쇼핑 센터가 아닌 경우 존재합니다.
                    </li>

                    <li>
                      예를 들어 교차로 / 상업 지역 또는 바쁜 지역에서 사람이 잘 통행합니다. 터미널에서의 그의 위치 /
                      부스는 쇼핑몰 내부이든 내부이든 전략적이어야합니다. 슈퍼마켓
                    </li>

                    <li>지역은 범람하지 않습니다</li>

                    <li>
                      바닥 면적 8-9m2 또는 최소 1.0m X 0.5m 크기의 기존 비즈니스 미터
                    </li>

                    <li>
                      특히 관리를 위해 적어도 하나의 고정 또는 휴대 전화 설정이 필요합니다. 전화선 열어 줘 (특히 집
                      전화) 멀지 않아야합니다. 제안 된 터미널 위치에서 1 미터 떨어져 있습니다.
                    </li>

                    <li>
                      폐쇄 (안전을 위해), 그러나 사람의 통행 / 입구 키오스크에서 정면이 있습니다. 주요 도로 또는
                      교통량이 많은 방향을 향해야합니다. 복권을 찾을 수없는 백화점이나 백화점의 경우 특히 운영
                      안전이있는 경우 포함되어야합니다. 보관 시간
                    </li>

                    <li>적절한 건조 지역 및 환기 (바람직하게는 에어컨 사용)</li>
                    <li>사용 가능한 접지 및 전원 지점이있는 일반 220VAC 전원 공급 장치를 사용합니다.</li>

                    <li>
                      모뎀 커넥터 및 복권 보관을위한 선반 / 미터 / 테이블 포함. 사용할 수없는 경우 생성시 담당자에게
                      알림이 전송됩니다.
                    </li>

                    <li>
                      터미널 사용에 대한 교육을받을 수있는 운영자와 함께 이 에이전트 당 전문 직원 1 명과 예비 인력 1
                      명이 있어야합니다. 조종사가 훈련 될 때 알려드립니다.
                    </li>

                    <li>
                      주요 영업 시간은 주 7 일 오전 7시 ~ 오후 8시 30 분입니다.
                    </li>
                  </ol>

                  <li>
                    기존 로또 상점에서 최소 100m 떨어져 있습니다. 산토리니의 추첨의
                  </li>

                  <li>승인 된 서비스 제공 업체의 사이트에 대한 기술 검토.</li>
                </ol>
              </div>

              <div
                class="faqHead"
                @click="fiveActive = !fiveActive"
                :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
                key="headFive"
              >
                <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
                <div>의료 지원에 대한 요구 사항은 무엇입니까?</div>
              </div>

              <div class="faqBody" v-if="fiveActive" key="headFive">
                <ul>
                  <li>약물 요청</li>

                  <ul>
                    <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                    <li>
                      정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                    </li>

                    <li>
                      병원 약국에서 비용을 지불하고 치료 의사가 서명 한 처방전에는 다음이 포함됩니다.
                      <br />
                      병원 약국에서받은 약이없는 경우 병원 약국에서 산토리니 복권으로 보낸 비 약물 증명서.
                    </li>

                    <li>
                      뒷면에 신청자의 서명이있는 신청자의 마지막 사진이있는 주민등록증 사본.
                    </li>
                  </ul>

                  <li>실험실 애플리케이션 / 진단 절차</li>

                  <ul>
                    <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                    <li>
                      정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                    </li>

                    <li>
                      치료 의사를 위해 정식으로 서명 된 신청서 (참고 : 의사 면허 번호 포함)
                    </li>

                    <li>
                      병원의 실험실 부서 /과에서 공식 가격을 제공합니다.
                      <br />
                      검사실 / 진단 절차를 사용할 수없는 경우 병원은 병원의 시술 미 활동 증명서를 제출해야합니다.
                      산토리니 복권에서
                    </li>

                    <li>
                      뒷면에 신청자의 서명이있는 신청자의 마지막 사진이있는 주민등록증 사본.
                    </li>
                  </ul>

                  <li>입원금 요청</li>

                  <ul>
                    <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                    <li>
                      정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                    </li>

                    <li>
                      계정 / 병원 청구서는 청구 / 신용 감독자가 검토합니다.
                    </li>

                    <li>
                      해당되는 경우 병원의 사회 복지 부서 또는 관리자의 추천서. 인증 및 청구
                    </li>
                  </ul>

                  <li>보청기 요청</li>

                  <ul>
                    <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                    <li>
                      청력 학자가 서명 한 오디오 평가 보고서 원본.
                    </li>

                    <li>모든 청각 센터에서 한두 가지 가격.</li>
                    <li>신청자의 마지막 사진이 서명 된 주민등록증 사본.</li>
                  </ul>

                  <li>임플란트 / 보철물 / 휠체어 요청</li>

                  <ul>
                    <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                    <ol>
                      <li>이식 요청 / 서약</li>

                      <ul>
                        <li>
                          정식으로 서명 된 의료 요약의 원본 또는 인증 사본. 치료하는 의사. (참고 : 면허를 소지 한 의사의
                          총 수).
                        </li>
                      </ul>

                      <li>휠체어 요청</li>

                      <ul>
                        <li>
                          의료 요약 또는 이용 가능한 의료 증명서의 원본 또는 인증 된 실제 사본. 치료 의사가 서명 한
                          휠체어 세부 정보 (참고 : 의사 면허 번호 포함)
                        </li>
                      </ul>
                    </ol>

                    <li>공식 가격, 두 (2) 다른 회사의 두 (2) 가격.</li>

                    <li>
                      휠체어 및 보철 장치를 요청하는 환자의 신체 이미지 1 개.
                    </li>
                  </ul>

                  <li>투석 요청</li>

                  <ul>
                    <li>Hon 회장 및 / 또는 총괄 관리자에게 신청서를 보냈습니다.</li>

                    <li>
                      정식으로 서명 된 의료 요약의 원본 / 인증 된 실제 사본. 치료하는 의사. (노트: 의사 면허 번호 포함)
                    </li>

                    <li>
                      부산 복권이 돈을 기부 한 콜센터 나 병원의 승인서.
                    </li>

                    <li>고객 서비스 센터 / 병원의 공식 가격 견적.</li>
                    <li>투석 센터 / 병원의 합격 증명서</li>

                    <li>
                      수술 후 병원에 용제 및 / 또는 약물이없는 경우 부산 복권으로 보내야합니다. 인증 병원에서 수술 후
                      투석액이나 약물이없는 경우.
                    </li>

                    <li>
                      뒷면에 신청자의 서명이있는 신청자의 마지막 사진이있는 주민등록증 사본.
                    </li>
                  </ul>
                </ul>
              </div>

              <div class="stillHaveQuestion" key="stillHaveQuestion">
                여전히 질문이 있습니까? 저희에게 연락하십시오 admin@busanlotteries.com
              </div>
            </transition-group>
          </div>

          <div v-else>
            <transition-group name="fadeCustom" leave-active-class="animated fadeOut fadeCustom-leave-active">
              <div
                class="faqHead"
                @click="oneActive = !oneActive"
                :class="{ borderNeeded: oneActive, borderAll: oneActive === false }"
                key="headOne"
              >
                <div class="faqSign">{{ oneActive ? '-' : '+' }}</div>
                <div>How to Claim Sweepstakes Prize?</div>
              </div>

              <div class="faqBody" v-if="oneActive" key="bodyOne">
                <p>
                  <b>Requirements and Guidelines</b>
                </p>

                <p>
                  Simply bring your Community Tax Certificate, Identification Card and the Winning ticket/s to the
                  Busan Lottery main office.
                </p>

                <p>
                  Present your winning ticket/s at the Prize Fund Division, Accounting and Budget Department. Affix your
                  signature at the back of winning ticket/s to establish your absolute ownership. Fill up claim form.
                </p>

                <p>
                  Proceed to Treasury Department. Present your Authenticated winning ticket/s and approved claim form
                  for immediate preparation of your check.
                </p>

                <p>
                  Have your check signed by the Chairman / General Manager. Then properly receive your winning prize /
                  check at the Treasury Department.
                </p>

                <p>Encash your check at the Busan National Bank.</p>

                <p>
                  <b>Conditions for Payment of Prizes</b>
                </p>

                <p>
                  Prizes shall be paid to the holder of share/s of a winning ticket upon presentation and surrender of
                  the same, provided that the ticket/s is/are free from any mutilation, erasure or stain, making any
                  number/s therein illegible, and provided further that no court injunction restraining the Busan
                  Lottery to pay is received before payment.
                </p>

                <p>All prizes paid are tax-free.</p>
              </div>

              <div
                class="faqHead"
                @click="twoActive = !twoActive"
                :class="{ borderNeeded: twoActive, borderAll: twoActive === false }"
                key="headTwo"
              >
                <div class="faqSign">{{ twoActive ? '-' : '+' }}</div>
                <div>How to Claim Lotto Prize?</div>
              </div>

              <div class="faqBody" v-if="twoActive" key="bodyTwo">
                <p>
                  Write your name and affix your signature at the back of your winning tickets before claiming your
                  prize.
                </p>
                <p>
                  Prize amounting to 1 EUR up to 100 EUR can be claimed at any authorized Lotto outlet or at the Busan
                  Lottery Branch Offices in your area.
                </p>
                <p>
                  Prizes worth more than 100 EUR up to 3.500 EUR can be claimed at any of the at the Busan Lottery
                  main office.
                </p>
                <p>The JACKPOT PRIZE should be validated and claimed at the Busan Lottery main office.</p>
                <p>For the system prize payout, please refer to the Prize Pay-Out Chart.</p>
              </div>

              <div
                class="faqHead"
                @click="threeActive = !threeActive"
                :class="{ borderNeeded: threeActive, borderAll: threeActive === false }"
                key="headThree"
              >
                <div class="faqSign">{{ threeActive ? '-' : '+' }}</div>
                <div>How to Apply as an Online Lottery Agent?</div>
              </div>

              <div class="faqBody" v-if="threeActive" key="bodyThree">
                <ol>
                  <li>
                    The applicant is requested to fill-up the On-Line Lottery Application Form
                    <br />The Application Form shall include the following attachments:
                  </li>
                  <ul>
                    <li>Sketch/Location Map of the proposed outlet site.</li>
                    <li>Picture of the building of the proposed outlet site.</li>
                  </ul>
                  <li>
                    Busan Lottery shall conduct the inspection and technical evaluation of the proposed outlet site/s.
                  </li>
                  <li>
                    The applicant shall be informed of the evaluation result. If the proposed outlet site is viable, the
                    following shall be required:
                  </li>
                  <ul>
                    <li>For Individual Applicant</li>
                    <li>For Corporation</li>
                  </ul>
                  <li>
                    Busan Lottery shall notify the applicant on the status of the application concerning the
                    availability of communication facilities in the proposed outlet prior to installation of facilities.
                  </li>
                  <li>The applicant shall be informed when to fabricate lotto booth.</li>
                  <li>For Terminal Installation.</li>
                  <li>Payment to Busan Lottery for Processing Fee.</li>
                  <li>Payment to Busan Lottery of an Installation Fee.</li>
                  <li>Payment of Surety Bond to the GSIS.</li>
                  <li>Request for training in the operation of terminal.</li>
                  <li>
                    Proceed to Merchandising Section for outlet provisions. Lottery outlets will be provided by the
                    Busan Lottery.
                  </li>
                  <li>Signing of the Agency Contract with the Busan Lottery.</li>
                  <li>For On-Line Activation.</li>
                </ol>

                <p>
                  <b>Note:</b>
                </p>
                <ul>
                  <li>
                    Please ensure that Application Form is complete and that all required documents are attached.
                    Incomplete requirements will not be processed.
                  </li>
                  <li>All application are subject to evaluation prior to approval.</li>
                </ul>
              </div>

              <div
                class="faqHead"
                @click="fourActive = !fourActive"
                :class="{ borderNeeded: fourActive, borderAll: fourActive === false }"
                key="headFour"
              >
                <div class="faqSign">{{ fourActive ? '-' : '+' }}</div>
                <div>On-Line Lottery Agents’ Application Requirements?</div>
              </div>

              <div class="faqBody" v-if="fourActive" key="bodyFour">
                <ol type="A">
                  <li>Applicant must be:</li>
                  <ul>
                    <li>a Greek citizen</li>
                    <li>at least 21 years old</li>
                  </ul>
                  <li>Applicant must accomplish and submit:</li>
                  <ul>
                    <li>Individual Applicant:</li>
                    <ol>
                      <li>Three (3) latest ID pictures (2 x 2);</li>
                      <li>
                        Three (3) latest ID pictures (2 x 2) of spouse; Letter of INTENT; On-Line Lottery PERSONAL DATA
                        SHEET;
                      </li>
                      <li>Proof of Income:</li>
                      <ul>
                        <li>For Self-employed:</li>
                        <ul>
                          <li>Income Tax Return</li>
                          <li>Registration of Business</li>
                          <li>Audited Financial Statements</li>
                        </ul>
                        <li>For Employed:</li>
                        <ul>
                          <li>Income Tax Return</li>
                          <li>Registration of Business</li>
                          <li>Certificate of Income</li>
                        </ul>
                      </ul>
                      <li>Proof of Ownership/Lease of Outlet</li>
                      <ul>
                        <li>For Owner:</li>
                        <ul>
                          <li>Land Title or TCT</li>
                        </ul>
                        <li>For Lessee:</li>
                        <ul>
                          <li>Contract of Lease (Notarized)</li>
                          <li>Building Owner’s Authorization Form</li>
                        </ul>
                      </ul>
                      <li>NBI Clearance (Current)</li>
                      <li>Brgy Clearance (Personal Record) Sketch/Location Map of the Proposed Agency Site</li>
                      <li>Photograph of the Vicinity Photograph of the Building</li>
                      <li>Photograph of the Interior</li>
                    </ol>
                    <li>For Corporation:</li>
                    <ol>
                      <li>Bio-data of Corporate Officers and Directors</li>
                      <li>
                        Photocopy of S.E.C Registration Photocopy of Articles of Incorporation Photocopy of By Laws
                        Latest audited Financial Statement I.T.R. for the immediately preceding year Letter of Intent
                        Contract of Lease Building Owner’s Authorization Sketch/Location Map of the Proposed Agency Site
                        Photograph of the Vicinity Photograph of the Building
                      </li>
                      <li>Photograph of the Interior</li>
                    </ol>
                  </ul>

                  <li>
                    Applicant must make sure that the Proposed Agency Site must comply with the following criteria:
                  </li>
                  <ol>
                    <li>
                      100 meters away from schools/place of learning, subject to Busan Lottery policies and existing
                      rules, except if the location is enclosed or a shopping center.
                    </li>
                    <li>
                      Good human traffic, i.e. situated in commercial or busy intersections/areas. The location of
                      terminal/booth should be strategic if within a mall or superstore.
                    </li>
                    <li>The area does not get flooded.</li>
                    <li>
                      Floor space of 8 – 9 sq. meters or available business counter measuring at least 1.0 m X 0.5 m
                    </li>
                    <li>
                      Preferable with at least one (1) telephone facility, landline or cellular, for hotline operations.
                      Such telephone (specially landline) should be situated at no more than one (1) meter away from the
                      proposed terminal location.
                    </li>
                    <li>
                      Enclosed (for security purposes) but with frontage from human traffic/entry. Frontage must face
                      main road or to the direction of major traffic flow. In cases of malls, shopping centers or
                      superstores, the lottery location need not be enclosed provided there is security of operation,
                      specially after store hours.
                    </li>
                    <li>Dry floor space and proper ventilation (preferably air-conditioned).</li>
                    <li>With regular power supply of 220 VAC, with grounding and available power point/s.</li>
                    <li>
                      With available shelf/counter/cabinet for terminal installation, modem and storage of lottery
                      materials. If not currently available, the agent will be advised on when to fabricate.
                    </li>
                    <li>
                      With operators to be made available for training in the operation of the terminals preferably one
                      dedicated personnel and a back-up personnel per terminal. This agent will be advised on when the
                      operators will be trained.
                    </li>
                    <li>Major operating hours fall within 7:00AM – 8:30PM, seven (7) days a week.</li>
                  </ol>
                  <li>
                    At least 100 meters away from any existing lotto outlet which shall be subject to Busan Lottery
                    governing rules.
                  </li>
                  <ol>
                    <li>National Capital Region – 100M</li>
                    <li>Southern Tagalog and Bicol Region – 200 – 250M</li>
                    <li>Northern and Central Luzon – 200 – 250M</li>
                  </ol>
                  <li>Approved technical site survey by carrier.</li>
                </ol>
              </div>

              <div
                class="faqHead"
                @click="fiveActive = !fiveActive"
                :class="{ borderNeeded: fiveActive, borderAll: fiveActive === false }"
                key="headFive"
              >
                <div class="faqSign">{{ fiveActive ? '-' : '+' }}</div>
                <div>What are the Requirements for Medical Assistance?</div>
              </div>

              <div class="faqBody" v-if="fiveActive" key="headFive">
                <ul>
                  <li>Request for Medicines</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                    <li>
                      Prescription duly signed by the attending physician with costing from the hospital pharmacy
                      included:
                      <br />In cases wherein medicines are unavailable from the Hospital Pharmacy, a Certification on
                      unavailability of medicines from the Hospital Pharmacy must be submitted to Busan Lottery.
                    </li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature indicated at the back.
                    </li>
                  </ul>
                  <li>Request for Laboratory/Diagnostic Procedures</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                    <li>Request from the attending physician duly signed (Note: Include physician’s license number)</li>
                    <li>
                      Official Price Quotation from the Laboratory Section/Department of the Hospital
                      <br />In cases wherein Laboratory/Diagnostic Procedure is unavailable from the hospital, a
                      Certification on unavailability of the procedure from the hospital must be submitted to Busan
                      Lottery.
                    </li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature indicated at the back.
                    </li>
                  </ul>
                  <li>Request for Payment Hospitalization</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>
                    <li>Statement of Account/Hospital Bill certified by the billing Officer/Credit Supervisor.</li>
                    <li>
                      Endorsement letter from the hospital’s Social Service if there is any, or from the Credit and
                      Collection Officer for Pay patients.
                    </li>
                  </ul>
                  <li>Request for Hearing Aid</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <li>Original copy of Audiological Evaluation Report duly signed by Audiometrist</li>
                    <li>One or two price quotations from any hearing aid centers</li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature
                    </li>
                  </ul>
                  <li>Request for Implants/Prosthetic Devices/Wheelchair</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>
                    <ol>
                      <li>Implant/phosthesis request</li>
                      <ul>
                        <li>
                          Original or certified true photocopy of medical abstract duly signed by the attending
                          physician. (Note: Include physician’s license number)
                        </li>
                      </ul>
                      <li>Wheelchair request</li>
                      <ul>
                        <li>
                          Original or certified true photocopy of medical abstract or medical certificate with
                          wheelchair specification signed by the attending physician. (Note: Include physician’s license
                          number)
                        </li>
                      </ul>
                    </ol>
                    <li>Two (2) official price quotations from two (2) different companies</li>
                    <li>
                      One (1) whole body picture of requesting patient for request for wheelchair and prosthetic
                      devices.
                    </li>
                  </ul>
                  <li>Request for Dialysis</li>
                  <ul>
                    <li>Letter of request addressed to the Hon. Chairman and/or General Manager</li>

                    <li>
                      Original/or certified true photocopy of medical abstract duly signed by the attending physician.
                      (Note: Include physician’s license number)
                    </li>

                    <li>
                      Endorsement letter from a Dialysis Center or Hospital where Busan Lottery allots an Endowment
                      Fund
                    </li>
                    <li>Official Price Quotation from the Dialysis Center/Hospital</li>
                    <li>Certification of Acceptance from Dialysis Center/Hospital</li>
                    <li>
                      In cases wherein dialysis solution and/or post-operative medicines is unavailable from the
                      hospital, a Certification on unavailability of the dialysis solution and/or post-operative
                      medicines from the hospital must be submitted to the Busan Lottery.
                    </li>
                    <li>
                      Photocopy of identification card with latest picture of the requesting person with his/her
                      signature indicated at the back.
                    </li>
                  </ul>
                </ul>
              </div>
              <div class="stillHaveQuestion" key="stillHaveQuestion">
                Still have question? Contact us at admin@Busanlottery.com
              </div>
            </transition-group>
          </div>
        </div>

        <RightBannerAds />
      </div>
    </div>

    <FooterSection />
  </div>
</template>

<script>
import FloatingMenu from '../components/FloatingMenu';
import FooterSection from '../components/FifthSection';
import MenuBar from '../components/MenuBar';
import LeftBannerAds from '../components/LeftBannerAds';
import RightBannerAds from '../components/RightBannerAds';

export default {
  components: {
    FloatingMenu,
    FooterSection,
    MenuBar,
    LeftBannerAds,
    RightBannerAds,
  },

  data: function() {
    return {
      oneActive: false,
      twoActive: false,
      threeActive: false,
      fourActive: false,
      fiveActive: false,
    };
  },

  methods: {
    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = '자주 묻는 질문 - 부산 복권';
      } else {
        document.title = 'FAQ - Busan Lotteries';
      }
    },
  },

  mounted() {
    this.setDocTitle();
  },
};
</script>

<style>
#faqPage {
  background: url('../assets/backgroundFirstSection.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 100vw;
  min-height: 100vh;
  padding: 5vw;
  padding-top: 7.5vw;
  box-sizing: border-box;
}

.faqPageTitle {
  font-size: 165%;
  font-weight: bold;
  color: var(--lightColor);
}

.faqContainer {
  margin-top: 1vw;
  overflow: auto;
  height: 85vh;
}

.faqSingle {
  margin-bottom: 4vw;
}

.faqHead {
  font-weight: bold;
  display: flex;
  align-items: center;
  background-color: var(--yellowPrim);
  color: var(--darkColor);
  margin-top: 4vw;
}

.borderAll {
  border-radius: 1vw;
  padding: 4.5vw;
}

.borderNeeded {
  border-radius: 1vw 1vw 0 0;
  padding: 4.5vw;
}

.faqBody {
  background-color: var(--lightColor);
  padding: 4.5vw;
  border-radius: 0 0 1vw 1vw;
  width: 81vw;
  line-height: 150%;
}

.faqBody p {
  margin-top: 0;
  margin-bottom: 3vw;
}

.faqSign {
  width: 2vw;
  margin-right: 3.5vw;
}

.fadeCustom-enter-active,
.fadeCustom-leave-active {
  transition: all 1s;
}

.fadeCustom-enter,
.fadeCustom-leave-to {
  opacity: 0;
  transform: translateY(-60px);
}

.fadeCustom-move {
  transition: transform 1s;
}

.fadeCustom-leave-active {
  position: absolute;
}

.faqBody ol {
  margin-top: 0;
  padding-left: 6vw;
}

.faqBody li {
  margin-top: 0;
  margin-bottom: 3vw;
}

.faqBody ul {
  margin-top: 0;
  padding-left: 6vw;
}

.stillHaveQuestion {
  color: var(--lightColor);
  margin-top: 4vw;
  text-align: center;
  font-weight: bold;
}

#faqDesktop {
  display: none;
}

@media screen and (min-width: 768px) {
  #faqDesktop {
    background-color: var(--darkColor);
    min-height: 100vh;
    display: block;
  }

  #faqDesktop .heroHeader {
    background-image: url('../assets/faq-banner.jpg'),
      linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6));
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-size: 6em;
    font-weight: bold;
    color: white;
    padding: 138px 0;
    background-position: top;
    text-shadow: 1px 1px 4px black;
  }

  .aboutDesktopField {
    line-height: 150%;
    font-size: 1.2em;
    width: 60%;
    margin: auto;
    height: 600px;
    overflow: scroll;
    background: var(--bluePrim-lighter-4);
    position: relative;
    top: -50px;
    padding: 15px 40px;
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    margin-bottom: -50px;
  }

  #faqDesktop .adsSpace1,
  #faqDesktop .adsSpace2 {
    width: 18%;
    position: relative;
    z-index: 3;
    text-align: center;
    border-radius: 5px;
    top: -50px;
    margin-bottom: -50px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  }

  #faqDesktop .faqHead.borderAll {
    border-radius: 5px;
    padding: 15px 25px;
    margin-top: 30px;
    background-color: var(--darkColor);
    color: var(--lightColor);
  }

  #faqDesktop .faqHead {
    margin-top: 30px;
    background-color: var(--darkColor);
    color: var(--lightColor);
    cursor: pointer;
  }

  #faqDesktop .faqBody {
    padding: 25px 30px;
    border-radius: 0 0 5px 5px;
    width: 100%;
    box-sizing: border-box;
  }

  #faqDesktop .faqBody p {
    margin-bottom: 20px;
  }

  #faqDesktop .faqBody ol {
    padding-left: 20px;
  }

  #faqDesktop .faqBody li {
    margin-bottom: 10px;
  }

  #faqDesktop .faqBody ul {
    padding-left: 40px;
  }

  #faqDesktop .faqSign {
    width: 0;
    margin-right: 30px;
  }

  #faqDesktop .borderNeeded {
    border-radius: 5px 5px 0 0;
    padding: 15px 25px;
  }

  #faqDesktop .stillHaveQuestion {
    margin-top: 30px;
    color: var(--bluePrim-darker-5);
  }
}
</style>
